var _defs, _g, _g2, _polygon;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 91 91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .st0 {\r\n        fill: #647f94;\r\n      }\r\n\r\n      .st1 {\r\n        fill: #65b794;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M79.6,89.6H3.5c-1.8,0-3.3-1.5-3.3-3.3V5.5C.1,3.7,1.6,2.2,3.5,2.2h51.1c1.8,0,3.3,1.5,3.3,3.3s-1.5,3.3-3.3,3.3H6.8v74.1h72.8c2.6,0,4.7-2.1,4.7-4.7v-41.6c0-1.8,1.5-3.3,3.3-3.3s3.3,1.5,3.3,3.3v41.6c0,6.3-5.1,11.3-11.3,11.3Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier1",
    "data-name": "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M67.5,75.9H18.7c-1.2,0-2.1-1-2.1-2.1V22c0-1.2,1-2.1,2.1-2.1h32.7c1.2,0,2.1,1,2.1,2.1s-.9,2.1-2.1,2.1h-30.6v47.5h46.6c1.7,0,3-1.4,3-3v-26.7c0-1.2,1-2.1,2.1-2.1s2.1,1,2.1,2.1v26.7c0,4-3.3,7.3-7.3,7.3Z"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "69.3 7.5 69.3 16 61.7 16 61.7 21 69.3 21 69.3 28 74.5 28 74.5 21.3 80.2 21.3 80.2 16.2 74.4 15.9 74.2 7.5 69.3 7.5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit2);
export default __webpack_public_path__ + "static/media/edit2.f4ec68732e413af9aca3d730113790db.svg";
export { ForwardRef as ReactComponent };